module.exports = __webpack_public_path__ + "static/media/toxic_pear.3dd888f5.svg";